import React from 'react';
import { useSearchSort } from '../../components/kitsters/useSearchSort';

const TableCompositeItem = ({ compositeitemdata }) => {
  const { view, query, setQuery, sortKey, sortDir, toggleSort } = useSearchSort(compositeitemdata);

  const rows = [];
    for (let i = 0; i < view.length; i++) {
      const a = view[i];
      rows.push(
        <tr key={a.composite_item_id || i}>

          <td>{a.name ?? '—'}</td>
          <td>{a.sku ?? '—'}</td>
          <td>{a.available_for_sale_stock ?? '—'}</td>
          <td>{a.actual_available_for_sale_stock ?? '—'}</td>
          <td>{a.status ?? '—'}</td>
          <td>
            <a
              href={`https://books.zoho.in/app/60022040726#/inventory/compositeitems/${a.composite_item_id}?filter_by=Status.All&per_page=200&sort_column=created_time&sort_order=D`}
              target="_blank"
              rel="noreferrer"
            >
              view
            </a>
          </td>
        </tr>
      );
    }

  const th = (key: string, label: string) => (
    <th className="th-sort" onClick={() => toggleSort(key)}>
      {label} {sortKey === key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );

  return (
      <>
        <input className="tbl-search" placeholder="Search…" value={query} onChange={e => setQuery(e.target.value)} />
        <table className="grid">
          <thead>
            <tr>
              {th('name', 'Name')}
              {th('sku', 'SKU')}
              {th('available_for_sale_stock', 'Accounting Stock')}
              {th('actual_available_for_sale_stock', 'Physical Stock')}
              {th('status', 'Status')}
              <th style={{ width: '80px' }}>Action</th>

            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </>
    );
};

export default TableCompositeItem;
